<div if.bind="ui.legalOpen" class="modal-overlay" click.trigger="ui.closeLegal()">
  <div class="legal-modal" click.trigger="$event.stopPropagation()">
    <div class="legal-modal__header">
      <h3 class="legal-modal__title">${ui.legalTitle}</h3>
      <button type="button" class="legal-modal__close" click.trigger="ui.closeLegal()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>
    <div class="legal-modal__body" innerhtml.bind="ui.legalBody"></div>
    <div class="legal-modal__footer">
      <button type="button" class="login-btn login-btn--primary" click.trigger="ui.closeLegal()">Close</button>
    </div>
  </div>
</div>
